import { Dropdown, Header, Navbar } from "rsuite";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useStore } from "../../context/AppContext";
import { authConstants } from "../../context/constants";
import { Perfil } from "../../types/admin-usuarios/Perfil";
import UserBadgeIcon from "@rsuite/icons/UserBadge";
import ExitIcon from "@rsuite/icons/Exit";
import logo from "./logoPJ.png";
import { useEffect, useState } from "react";
import { TypeDocument } from "../../enums/TypeDocument.enum";

export default function TopBar({
  expand,
  setExpand,
}: {
  expand: boolean;
  setExpand: any;
}) {
  const { state, dispatch } = useStore();
  const [url, setUrl] = useState<string>(TypeDocument.ACUERDOS);
  const [amnistia, setAmnistia] = useState<boolean>(false)

  useEffect(() => {
    setUrl(getRoute());
  }, []);

  function getRoute() {
    // For testting dinamic header
    // const url = "https://gestiondocumentalsentencias.pjedomex.gob.mx/";
    // const url = "https://gestiondocumentalacuerdos.pjedomex.gob.mx/";
    // const url = "https://gestiondocumentaljurisprudencias.pjedomex.gob.mx/";
    // const url = "https://gestiondocumental.pjedomex.gob.mx/busqueda-documentos"
    // const url = "https://gestiondocumentalamnistia.pjedomex.gob.mx";


    // const shadow = url
    //   .substring(
    //     url.indexOf("gestiondocumental") + 17,
    //     url.indexOf(".")
    //   )
    //   .toUpperCase() as keyof typeof TypeDocument;
    const shadow = window.location.hostname
      .substring(
        window.location.hostname.indexOf("gestiondocumental") + 17,
        window.location.hostname.indexOf(".")
      )
      .toUpperCase() as keyof typeof TypeDocument;


    if (Object.keys(TypeDocument).includes(shadow)) {
      if (TypeDocument[shadow] === TypeDocument.AMNISTIA) {
        setAmnistia(true)
      }
      return shadow;
    } else {
      return TypeDocument.ACUERDOS;
    }


  }

  const renderDrop: any = (props: any, ref: any) => {
    return (
      <div className="d-flex flex-row " {...props} ref={ref}>
        {/* <Avatar src="/images/users/user.svg" circle size="md" alt="avatar" /> */}
        <div className="align-self-center ms-2">
          {/* d-none d-md-block  */}
          <p className="m-0 fw-bolder fs-6">
            {state.user.credentials?.fullname}
          </p>
          <p
            className="m-0 fw-bold text-info text-opacity-50"
            style={{ fontSize: "12px" }}
          >
            {state.user.currentperfil?.name}
          </p>
        </div>
      </div>
    );
  };

  function logout() {
    dispatch({ type: authConstants.LOGOUT });
  }

  function changeProfile(profile: Perfil) {
    dispatch({ type: authConstants.CHANGE_PROFILE, payload: profile });
  }
  return (
    <Header className="shadow-sm">
      <Navbar className="bg-primary text-white px-2 py-2">
        {state.user.authenticated ? (
          <div className="d-flex flex-row justify-content-between align-items-center w-100">
            <>
              <div
                onClick={() => setExpand(!expand)}
                className="cursor-pointer"
              >
                <FontAwesomeIcon
                  icon={expand ? faChevronLeft : faBars}
                  size="2x"
                  className="btn-menu"
                />
              </div>
            </>
            <div className="px-2 tb-menu">
              <Dropdown
                renderToggle={renderDrop}
                placement="bottomEnd"
                activeKey={state.user.currentperfil?._id}
              >
                <Dropdown.Menu
                  title="Perfiles"
                  icon={<UserBadgeIcon />}
                  style={{ top: "34px", left: "0px" }}
                >
                  {state.user.perfiles &&
                    state.user.perfiles.map((p: Perfil) => (
                      <Dropdown.Item
                        eventKey={p._id}
                        key={"ddp" + p._id}
                        onClick={() => changeProfile(p)}
                      >
                        {p.name}
                      </Dropdown.Item>
                    ))}
                </Dropdown.Menu>
                <Dropdown.Separator />
                <Dropdown.Item icon={<ExitIcon />} onClick={() => logout()}>
                  Cerrar sesión
                </Dropdown.Item>
              </Dropdown>
            </div>
          </div>
        ) : (
          <div className="d-flex flex-row w-100 px-1">
            <div className="d-flex flex-row">
              <Link
                to="/"
                className="d-flex flex-row text-reset text-decoration-none"
              >
                <img
                  src={logo}
                  height="36"
                  alt="logo"
                  className="border-end pe-2"
                />
                <h4 className="no-select ps-2 align-self-center d-none d-sm-block">
                  {window.location.hostname === 'localhost' || window.location.hostname.split('.')[0] === 'gestiondocumental' ? (
                    "Sistema de Búsqueda de Sentencias, Acuerdos y Jurisprudencias"
                  ) : (
                    <>
                      Sistema de búsqueda de{" "}
                      {amnistia === true
                        ? `resoluciones de amnistia`
                        : url.toLowerCase() !== TypeDocument.SENTENCIAS
                          ? url.toLocaleLowerCase()
                          : `${url.toLocaleLowerCase()} en versión pública.`}
                    </>
                  )}
                </h4>
              </Link>
            </div>
          </div>
        )}
      </Navbar>
    </Header>
  );
}
